import { Component, h, Element, Prop } from '@stencil/core';

/**
 * @slot home - Designed to override the original home icon
 * @slot - Designed to add breadcrumb-item elements
 */

@Component({
  tag: 'sy-breadcrumb',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class Breadcrumb {
  @Element() el: HTMLSyBreadcrumbElement;

  /**
   * Url to the home page. If this property is set, a home icon is added automatically.
   */
  @Prop({ reflect: true }) home: string;

  /**
   * Target of home link. Must be used along with the `home` property.
   */
  @Prop({ reflect: true }) homeTarget: '_blank' | '_self' | '_parent' | '_top' = '_self';

  /**
   * Char used to devide breadcrumb sections
   */
  @Prop({ reflect: true }) separator = '/';

  /**
   * Indicate if there will be a separator at the end
   */
  @Prop() endWithSeparator = false;

  componentWillLoad() {
    if (!this.el.hasAttribute('role')) {
      this.el.setAttribute('role', 'nav');
    }
  }

  render() {
    return (
      <ol style={{ '--separator': `"${this.separator}"` }}>
        {this.home ? (
          <sy-breadcrumb-item class="sy-breadcrumb-item-home" href={this.home} target={this.homeTarget}>
            <sy-icon name="house"></sy-icon>
          </sy-breadcrumb-item>
        ) : (
          ''
        )}
        <slot name="home"></slot>
        <slot></slot>

        {this.endWithSeparator && <div class="sy-breadcrumb-final-separator">{this.separator}</div>}
      </ol>
    );
  }
}
